import { render, staticRenderFns } from "./IdeaQuestion.vue?vue&type=template&id=ed228098"
import script from "./IdeaQuestion.vue?vue&type=script&lang=js"
export * from "./IdeaQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports